<template>
  <div class="Login">
    <div class="header" v-if="!$store.state.mediaPhone">
      <link_wp :link="topLink[0]" :isBefore="1"></link_wp>
      <link_wp :link="topLink[1]"></link_wp>
    </div>
    <div class="form" @keyup.enter="submit">
      <div class="title fs18">{{title}}</div>
      <my_input v-for="f in forms" :key="f.label" :title="f.title" :type="f.type" :placeholder="f.placeholder" v-model="fm[f.label]"
                :error="error[f.label]"></my_input>
      <span :title="checkLogin()?'':'请先填写表单'"><my_button class="btn" :value="btn" @click.native="submit"
                                                               :disable="!checkLogin()"></my_button></span>
      <div class="tips">
        <div class="tip" v-for="tip in tips">
          <my_link :link="tip.link" :inputStyle="tip.style"></my_link>
        </div>
      </div>
    </div>
    <!-- <m_bottom_bar v-if="$store.state.mediaPhone"></m_bottom_bar> -->
  </div>

</template>

<script>
 import Logo from '@/components/Logo.vue'
 import MyLink from '@/components/Link.vue'
 import LinkWP from '@/components/LinkWithPseudo.vue'
 import MyInput from '@/components/Input.vue'
 import MyButton from '@/components/Button.vue'
 import MBottomBar from '@/components/mobile/MBottomBar.vue'

 export default {
   name: 'Login',
   data() {
     return {
       fm: {
         phone: '',
         password: ''
       },
       error: {
         phone: '',
         password: ''
       },
       reseting: false,
       btn: '登录'
     }
   },
   watch: {
     fm: {
       handler() {
         if (!this.reseting)
           this.resetError()
       },
       deep: true
     }
   },
   methods: {
     resetError() {
       this.error = {
         phone: '',
         password: ''
       }
     },
     checkLogin() {
       return this.fm.phone && this.fm.password
     },
     submit() {
       if(!this.checkLogin())
         return
       this.btn = '登录中'
       let data = new FormData()
       data.set('phone', this.fm.phone)
       data.set('password', this.fm.password)
       this.$http.post('/api/login', data)
           .then(res => {
             console.log(res)
             this.$store.commit('SET_TOKEN', res.data)
             this.$http.get('/api/login/me')
                    .then(me => {
                      let user = me.data
                      this.$store.commit('SET_USER', user)
                      if (me.data.role == 'teacher') {
                        window.open(this.$store.state.gamelink + this.$store.state.auth.token.token, '_blank')
                        this.$router.replace({name: 'frontpage'})
                      }
                      let classrooms = this.$http.get('/api/classroom');
                      let gameState = this.$http.get('/api/user/game_state');
                      Promise.all([classrooms, gameState])
                             .then(ress => {
                               let crs = ress[0].data
                               this.$store.commit("SET_CLASSROOMS", crs.classrooms)
                               this.$store.commit("SET_MY_CLASSROOM", crs.me_v2);
                               this.$store.commit("SET_GAME_STATE", ress[1].data)
                             })
                             .catch(e => {})
                             .then(res => {
                               if(this.$store.state.mediaPhone) {
                                 this.$router.push({name: 'WapSharePage'})
                               }
                               else if (this.$store.state.route.redirect) {
                                 this.$store.commit('UNSET_REDIRECT')
                                 this.$router.history.go(-1)
                               }
                               else {
                                 this.$router.replace({name: 'frontpage'})
                               }
                             })
                      })
           }).catch(e => {
             let error = e.response.data.errors
             this.btn = '登录'
             this.reseting = true
             for (let e in error) {
               this.fm[e] = ''
               this.error[e] = error[e]
             }
             this.$nextTick(() => {
               this.reseting = false
             })
           })
     }
   },
   computed: {
     topLink() {
       return this.$store.state.account.login.links
     },
     logo() {
       return this.$store.state.logo.mainBlack
     },
    logo2() {
      return this.$store.state.logo.tulingWhite
    },
    logo2Style() {
      return {
        height: '3em',
        'margin-left': '50px'
      }
    },
     title() {
       return '账号登录'
     },
     forms() {
       return this.$store.state.account.login.forms
     },
     tips() {
       return [
         {
           link: {
             text: '忘记密码？',
             link: {name: 'account', params: {type: 'loginWithCode'}}
           },
           style: {
             color: '#3388FF'
           }
         }
         ,
         /* {
          *   link: {
          *     text: '没有账号？去注册',
          *     link: {name: 'account', params: {type: 'register'}},
          *     disable: true
          *   },
          *   style: {
          *     color: '#3388ff'
          *   }
          * } */
       ]

     }
   },
   components: {
     my_input: MyInput,
     my_button: MyButton,
     my_link: MyLink,
     link_wp: LinkWP,
     logo: Logo,
     m_bottom_bar: MBottomBar
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Login{
   text-align: center;
   width: 32.08vw;
   height: 34.0625vw;
   background-color: white;

   box-sizing: border-box;
   padding-top: 1.32vw;
   padding-bottom: 1.2vw;
   padding-left: 3.18vw;
   padding-right: 3.18vw;

   display: flex;
   flex-direction: column;
   justify-content: space-between;
 }
.logos{
  display: flex;
  align-items: center;
  justify-content: center;
}
 .header{
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin-bottom: 1.5vw;
 }

 .btn{
   margin-top: 0.99vw;
 }

 .title{
   color: #333333;
   margin-bottom: 10.17vw;
   margin-top: 1.875vw;
 }

 .tips{
   margin-top: 1.3vw;
   display: flex;
   justify-content: space-between;
 }

 @media (min-width: 320px) and (max-width: 480px){
   .Login{
     width: 100vw;
     height: 100%;
     align-items: center;
     justify-content: center;
   }

   .form{
     height: 60%;
     width: 80%;
   }

   .title{
     margin-bottom: 10vh;
   }

   .btn{
     margin-top: 4vw;
   }

   .tips{
     margin-top: 4vw;
     font-size: 14px;
   }
 }
</style>
